import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/services/util.service';
import { AuthService } from '../auth/auth.service';
import { ProductConversionsService } from './product-conversions.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject, Observable, throwError, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import * as _ from "lodash";

const BackendUrl = environment.BackendUrl;

@Injectable({
  providedIn: "root",
})
export class SubstitutionService {
  notifySubstitutionListChanged(): void {
    this.substitutionListChanged.next();
  }

  getSubstitutionDataUpdated = new Subject<any>();
  getSubstitutionAllDataUpdated = new Subject<any>();
  /** Header substitution badge. Emitted after a substitution is added or removed. */
  substitutionListChanged = new Subject<void>();
  getSubstitutionListUpdated = new Subject<any>();
  getSubstitutionDataFileUpdated = new Subject<any>();
  getSubstitutionProductDataUpdated = new Subject<any>();
  getSubstitutionWorkstepProductDataUpdated = new Subject<any>();
  getCreatePDFUpdated = new Subject<any>();
  getAllSubstitutionDataUpdated = new Subject<any>();
  removeSubstitutionProductDataUpdated = new Subject<any>();

  constructor(
    private http: HttpClient,
    private utilService: UtilService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private productConversions: ProductConversionsService
  ) {}

  /**
   * Convert date from string to Date object
   */
  convertStringToDate(data) {
    var i, dataLength;

    if (_.isArray(data)) {
      dataLength = data.length;
      for (i = 0; i < dataLength; i += 1) {
        data[i].last_chaged = this.utilService.convertStringToDate(
          data[i].last_changed
        );
      }
    } else if (_.isObject(data)) {
      data.last_changed = this.utilService.convertStringToDate(
        data.last_changed
      );
    }

    return data;
  }

  /** One response per caller. The header badge and the substitution list must not share getSubstitutionAllDataUpdated. */
  getAll$(): Observable<any> {
    const token = localStorage.getItem('token');
    const raw = localStorage.getItem('selectedOrganisation');
    if (raw == null) {
      return of(null);
    }

    let orgId: any;
    try {
      orgId = JSON.parse(raw).id;
    } catch {
      return of(null);
    }
    if (orgId == null) {
      this.authService.logout();
      return of(null);
    }

    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: token,
    });

    return this.http
      .get(
        BackendUrl + '/organisations/' + orgId + '/substitution/getsubstitution',
        { headers }
      )
      .pipe(
        take(1),
        catchError((error) => {
          if (error?.status === 401) {
            this.authService.logout();
          }
          return of(null);
        })
      );
  }

  getAll() {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedOrganisation") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedOrganisation")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .get(
          BackendUrl +
            "/organisations/" +
            orgId +
            "/substitution/getsubstitution",
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionAllDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionAllDataUpdated.next(null);
          },
        });
    }
  }

  getAllForDashboard(ids) {
    let token = localStorage.getItem("token");
    if (localStorage.getItem("selectedOrganisation") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedOrganisation")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      let params = new HttpParams();
      params = params.append("data", ids);

      this.http
        .get(
          BackendUrl +
            "/organisations/" +
            orgId +
            "/substitution/getsubstitutionfordashboard",
          { headers: headers,
            params: params }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getAllSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getAllSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  getSubstitutionReport(ids) {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      let params = new HttpParams();
      params = params.append("data", ids);

      this.http
        .get(BackendUrl + "/organisations/" + orgId + "/substitution/getsubstitutionforreport", {
          headers: headers,
          params: params
        })
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  getPDFAsTrustedResourceUrl(thisid, orgId) {

    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get(BackendUrl + '/organisations/' + orgId + '/substitution/' + thisid + "/getSinglePDF", {headers: headers, responseType: "arraybuffer"}).pipe(take(1)).subscribe({next: response => {

        var file = new Blob([response], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.getSubstitutionDataUpdated.next(fileURL);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getSubstitutionDataUpdated.next(null);
      }
    });
  }

  getSingle(id): Observable<any> {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") == null) {
      return of(null);
    }

    var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
    if (orgId == null) {
      this.authService.logout();
    }

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    return this.http
      .get(BackendUrl + "/organisations/" + orgId + "/substitution/" + id, {
        headers: headers,
      })
      .pipe(
        map((response) => {
          this.convertStringToDate(response);
          return response;
        }),
        catchError((error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          return of(null);
        })
      );
  }

  createSubstitution(info) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      let token = localStorage.getItem("token");

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .post<any>(
          BackendUrl + "/organisations/" + orgId + "/substitutions",
          info,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
            this.notifySubstitutionListChanged();
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  addToSubstitutionList(sareq_id, sub_list) {

    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    var info = {'sareq_id': sareq_id,'sub_list': sub_list}

    this.http
      .post<any>(BackendUrl + "/substitution/addToSubstitutionList", info, { headers: headers }
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getSubstitutionListUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getSubstitutionListUpdated.next(null);
        },
    });
  }

  getSubstitutionList() {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http.get(BackendUrl + "/substitution/getAllSubstitutionListProducts/", {headers: headers,})
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getSubstitutionListUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getSubstitutionListUpdated.next(null);
        },
      });
  }

  getSingleItemInSubstitutionList(sareqId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http.get(BackendUrl + "/substitution/getSingleSubstitutionListProducts/" + sareqId, {headers: headers,})
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getSubstitutionListUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getSubstitutionListUpdated.next(null);
        },
      });
  }

  deleteSubstitutionListItem(id) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete(
        BackendUrl + "/substitution/removeSubstitutionProduct/" + id,
        { headers: headers }
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getSubstitutionListUpdated.next(true);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getSubstitutionListUpdated.next(true);
        },
      });
  }

  removeSubstitutionDoneProduct(id, department) {
    if (department == null) {
      this.authService.logout();
    }

    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    const body = { department }; // Add department to the payload

    this.http
        .delete<any>(
          BackendUrl + "/substitution/deletesubstitutedproduct/" + id,
          { headers: headers, body: body }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
  }

  updateSubstitution(id, info) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      let token = localStorage.getItem("token");

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .put<any>(
          BackendUrl + "/organisations/" + orgId + "/substitutions/" + id,
          info,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  updateSubstitutionStatus(id, info) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      let token = localStorage.getItem("token");

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .put<any>(
          BackendUrl + "/organisations/" + orgId + "/substitutionsstatus/" + id,
          info,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  dosubstitution(item) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      let token = localStorage.getItem("token");

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .put<any>(
          BackendUrl + "/organisations/" + orgId + "/dosubstitution",
          item,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  deleteSubstitution(id) {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .delete(
          BackendUrl + "/organisations/" + orgId + "/substitutions/" + id,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(true);
            this.notifySubstitutionListChanged();
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(true);
          },
        });
    }
  }

  deleteDepartmentSubstitution(id, depid) {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = depid;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .delete(
          BackendUrl + "/organisations/" + orgId + "/substitutionsThis/" + id,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(true);
            this.notifySubstitutionListChanged();
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(true);
          },
        });
    }
  }

  getAllProducts() {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .get(
          BackendUrl +
            "/organisations/" +
            orgId +
            "/getallproductssubstitution",
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.productConversions.convertPictogramsOnProductArray(response);
            this.productConversions.convertProtectiveGearImagesOnProductArray(
              response
            );
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  getSingleProduct(id) {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .get(
          BackendUrl +
            "/organisations/" +
            orgId +
            "/substitution/product/" +
            id,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.productConversions.convertPictogramsOnProductArray(response);
            this.productConversions.convertProtectiveGearImagesOnProductArray(
              response
            );
            this.getSubstitutionProductDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionProductDataUpdated.next(null);
          },
        });
    }
  }

  getSingleWorkstepProduct(id): Observable<any> {
    return this.getConvertedProduct(
      id,
      "/substitution/workstepproduct/"
    );
  }

  getSingleProductAny(id): Observable<any> {
    return this.getConvertedProduct(
      id,
      "/substitution/productany/"
    );
  }

  private getConvertedProduct(id, path): Observable<any> {
    if (!id) {
      return of(null);
    }

    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") == null) {
      return of(null);
    }

    var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
    if (orgId == null) {
      this.authService.logout();
    }

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    return this.http
      .get(BackendUrl + "/organisations/" + orgId + path + id, {
        headers: headers,
      })
      .pipe(
        map((response: any) => {
          this.productConversions.convertPictogramsOnProduct(response[0]);
          this.productConversions.convertProtectiveGearImagesToProduct(response[0]);
          this.productConversions.convertPhrasesOnProduct(response[0]);
          return response[0];
        }),
        catchError((error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          return of(null);
        })
      );
  }

  checkIfProductExists(object) {
    let token = localStorage.getItem("token");
    var objectid = object.subprodid;

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      this.http
        .get(
          BackendUrl +
            "/organisations/" +
            orgId +
            "/substitution/checkifexists/" +
            objectid,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  getFileAsTrustedResourceUrl(id, mimeType = "image/jpeg") {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });
      const blobType = mimeType || "application/octet-stream";

      this.http
        .get(
          BackendUrl +
            "/organisations/" +
            orgId +
            "/substitution/picturesub/" +
            id,
          { headers: headers, responseType: "blob" }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            var file = new Blob([response], { type: blobType });
            if (file.size !== 0) {
              const unsafeImg = URL.createObjectURL(file);
              var image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
              this.getSubstitutionDataFileUpdated.next(image);
            }
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  getcDocFileWithId(fileId, mimeType = "application/pdf") {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });
      const blobType = mimeType || "application/octet-stream";

      this.http
        .get(
          BackendUrl +
            "/organisations/" +
            orgId +
            "/substitution/filesub/" +
            fileId,
          { headers: headers, responseType: "arraybuffer" }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            var file = new Blob([response], { type: blobType });
            var fileURL = URL.createObjectURL(file);
            this.getSubstitutionDataUpdated.next(fileURL);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  copySubstitution(info) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }
      let token = localStorage.getItem("token");
      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });
      this.http
        .post<any>(
          BackendUrl + "/organisations/" + orgId + "/copysubstitutions",
          info,
          { headers: headers }
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.getSubstitutionDataUpdated.next(response);
          },
          error: (error) => {
            if (error.status === 401) {
              this.authService.logout();
            }
            this.getSubstitutionDataUpdated.next(null);
          },
        });
    }
  }

  substituteProduct(oldProductId, newProductId, departments) {
    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
      }
      var info = { oldProductId: oldProductId, newProductId: newProductId, departments:departments };
    }
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .put<any>(
        BackendUrl + "/organisations/" + orgId + "/substituteProduct",
        info,
        { headers: headers }
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.getSubstitutionDataUpdated.next(response);
        },
        error: (error) => {
          if (error.status === 401) {
            this.authService.logout();
          }
          this.getSubstitutionDataUpdated.next(null);
        },
      });
  }

  createPDFSubstitution(id) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    let params = new HttpParams();
    params = params.append("token", token);

    this.http
      .get(BackendUrl + "/organisations/" + id + "/createpdfsubstitution", {
        headers: headers,
        responseType: "arraybuffer",
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getCreatePDFUpdated.next(response);
        },
        error: (error) => {
          this.getCreatePDFUpdated.next(null);
        },
      });
  }

  checkIfSubstitutionExists( object ) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    let params = new HttpParams();
    params = params.append("object", JSON.stringify(object));

    this.http
      .get(BackendUrl + "/substitution/checkifsubstitutionexists", {
        headers: headers,
        params: params
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getSubstitutionDataUpdated.next(response);
        },
        error: (error) => {
          this.getSubstitutionDataUpdated.next(null);
        },
      });
  }

  getAISubstitutionProposals(substitutionId: number, productId: number, extraInput?: string): Observable<any> {
    let token = localStorage.getItem("token");

    if (localStorage.getItem("selectedDepartment") != null) {
      var orgId = JSON.parse(localStorage.getItem("selectedDepartment")).id;
      if (orgId == null) {
        this.authService.logout();
        return throwError(() => new Error("No organization selected"));
      }

      const headers = new HttpHeaders({
        Accept: "application/json",
        Authorization: token,
      });

      const body: Record<string, unknown> = {
        substitution_id: substitutionId,
        product_id: productId
      };
      if (extraInput != null && String(extraInput).trim() !== '') {
        body.extra_prompt = String(extraInput).trim();
      }

      return this.http.post<any>(
        BackendUrl + "/organisations/" + orgId + "/substitution/ai-proposals",
        body,
        { headers: headers }
      );
    }
    return throwError(() => new Error("No department selected"));
  }

  public getSubstitutionDataListener() {
    return this.getSubstitutionDataUpdated.asObservable();
  }

  public getSubstitutionAllDataListener() {
    return this.getSubstitutionAllDataUpdated.asObservable();
  }

  public getSubstitutionListListener() {
    return this.getSubstitutionListUpdated.asObservable();
  }

  public getAllSubstitutionDataListener() {
    return this.getAllSubstitutionDataUpdated.asObservable();
  }

  public getSubstitutionDataFileListener() {
    return this.getSubstitutionDataFileUpdated.asObservable();
  }

  public getSubstitutionProductDataListener() {
    return this.getSubstitutionProductDataUpdated.asObservable();
  }

  public getCreatePDFUpdatedListener() {
    return this.getCreatePDFUpdated.asObservable();
  }

  public getSubstitutionWorkstepProductDataListener() {
    return this.getSubstitutionWorkstepProductDataUpdated.asObservable();
  }

  removeSubstitutionProductDataListener() {
    return this.removeSubstitutionProductDataUpdated.asObservable();
  }
}



